// dilip 01/23/2023 2698964415 Filter Criteria changes for Data Import.
// dilip 01/24/2023 2698964415 Filter Criteria save api payload changes for Data Import.
// dilip 01/25/2023 2698964415 Filter Criteria UI change for Data Import.
// Sohel 01/31/2023 2698964415 label changes
// Dilip 02/02/2023 2698964415 changed code and description label changes
// Sohel 02/08/2023 2701335619 Implement Usage Functionality
// Suresh Peddavoora 02/24/2023 2701335619 New UI changes

// Akhila 03/08/2023 2698964415 added AND OR radio button in filter stepper
// Ravi 03/08/2023 2698964415 rename Filter Criteria to Duplicate Criteria
// Sohel 03/24/2023 2698964415 rename Field Name
// Akhila 05/31/2023 2698964415 unsaved changes bug fixed
// Ravi 05/31/2023 2698964415  changed delete popup message
// Akhila 06/12/2023 2698964415 added role access
// Akhila 06/14/2023 2700708915 bug fix unsaved changes on save button
// Ravi 06/19/2023 2700708915 Added Breadcrum in popup
// Ravi 06/23/2023 2698964415 fixed submit issue
// Sohel 10/11/2023  2698964415 Change default filter condition
// Sohel 10/11/2023 2698964415 Duplicate Criteria SQL Output Changes
// Sohel 12/12/2023 2701335619 label name change code to name 

import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  Tooltip,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import {Field, FieldArray, Form, Formik} from 'formik';
import FilterCriteriaBuilder, {
  hideValuesConditions,
  typeOptions,
} from '../../../../../components/SqlRuleBuilder/FilterCriteriaBuilder';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import BreadCrums from '../../../../../util/BreadCrum';
import {getOptions} from '../../../../../components/SqlRuleBuilder/utils';
import {
  fetchFilterCriteriaData,
  fetchSelectedProcessorFieldsData,
  postFilterCriteriaData,
  resetFilterCriteriaData,
  resetBasicInfo as resetDownloadConfigurationInfo,
  fetchRecordFormatFieldsData,
} from '../../../../../redux/reducers/DataManagerRecord';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {resetBasicInfo} from '../../../../../redux/reducers/DataManager';
import DialogBox from '../../../../../components/DialogBox';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const FilterCriteria = ({
  handleBack,
  handleNext,
  exportManagerRecord,
  setValue,
  isDataManager,
  handleDirty,
  dmTempRecordAccess,
  editExisting,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [deletedRules, setDeletedRules] = useState([]);
  const filterMethodRef = useRef({});
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const resultRef = useRef();
  const saveRef = useRef();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const filterCriteriaType = isDataManager ? 'DataManager' : 'Record';
  const {
    addFilterCriteriaStatus,
    filterCriteriaSuccessMsg,
    isFilterCriteriaLoading,
    filterCriteriaErrorMsg,
    recordFormatFieldsData,
    dataManagerRecordId
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {basicInfoErrorMsg, basicInfoSuccessMsg, isBasicInfoLoading,dataManagerId} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  const {
    recordCode,
    selectedProcessorFields,
    filterCriteriaData,
    basicInfoData: infoData,
  } = useSelector(({ dataManagerRecord }) => dataManagerRecord);
  const {
    basicInfoSuccessMsg: successMsg,
    basicInfoErrorMsg: errorMsg,
    isBasicInfoLoading: loading,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetDownloadConfigurationInfo());
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  const initialVal = {
    sqlExpression: '',
    formulaExpression: '',
    resultExpCondition: 'AND',
    sqlRules: [],
  };
  // let initialVal = {
  //   sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : "",
  //   formulaExpression: filterRuleGroupData?.formulaExpression
  //     ? filterRuleGroupData?.formulaExpression
  //     : "",
  //   resultExpCondition:
  //     filterRuleGroupData?.defaultOperator == null ? "AND" : filterRuleGroupData?.defaultOperator,
  // };
  // const {
  //   addRuleData,
  //   userMetrix,
  //   isLoading,
  //   addRuleGroupStatus,
  //   addRuleStatus,
  //   testFilterResponse,
  //   allFilterCodeAndDisplayName,
  // } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const [isDelete, setIsDelete] = useState(false);
  const currentDeleteIndex = useRef(null);
  const [initialValues, setInitialValues] = useState(initialVal);

  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);
  const arrayHelperRef = useRef();

  useEffect(() => {
    if (dataManagerRecordId && !isDataManager) {
      dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId));
      dispatch(fetchFilterCriteriaData(dataManagerRecordId, filterCriteriaType));
    }
  }, [dataManagerRecordId]);

  useEffect(() => {
    if (infoData?.recordCode && !isDataManager) {
      dispatch(fetchRecordFormatFieldsData(type, infoData?.dataManagerRecordId));
    }
  }, [infoData]);

  const validationSchema = Yup.object().shape({
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed()
          .when('condition', {
            is: (val) => {
              return !['isNotBlank', 'isBlank'].includes(val?.value);
            },
            then: Yup.mixed().required('Value is required'),
          })
          .nullable(),
        type: Yup.mixed().test('type', 'Type is required', (value, ctx) => {
          if (!value?.value && !hideValuesConditions?.includes(ctx.parent?.condition?.value)) {
            return false;
          } else {
            return true;
          }
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
      }),
    ),
    sqlExpression: Yup.string().required('Result Expression is required'),
  });
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (!filterCriteriaData?.code) {
      const newInitialVal = {
        sqlExpression: 'S1 AND S2',
        resultExpCondition: 'AND',
      };
      const sqlRules = [
        {
          field: {
            fieldType: 'Text',
            globalField: 'client_reference_number',
            fieldName: 'Client Reference Number',
            repositoryName: 'Account',
          },
          ruleCode: 'S1',
          value: '',
          value1: '',
          condition: {label: 'Is', value: '='},
          type: typeOptions[0],
        },
        {
          field: {
            fieldType: 'Text',
            globalField: 'client_number',
            fieldName: 'Client Number',
            repositoryName: 'Account',
          },
          ruleCode: 'S2',
          value: '',
          value1: '',
          condition: {label: 'In', value: 'in'},
          type: typeOptions[0],
        },
      ];
      setInitialValues((prev) => ({...prev, ...newInitialVal, sqlRules: sqlRules}));
    }
  }, []);

  useEffect(() => {
    if (filterCriteriaData?.code) {
      const newInitialValues = {...initialValues};
      newInitialValues.resultExpCondition =
        filterCriteriaData?.defaultOperator == null ? 'AND' : filterCriteriaData?.defaultOperator;
      newInitialValues.sqlExpression = filterCriteriaData?.resultExpression;
      const newRules =
        filterCriteriaData?.dmFilterSqlRuleRequests?.length > 0 &&
        filterCriteriaData?.dmFilterSqlRuleRequests?.map((el) => {
          return {
            ...el,
            value:
              el.type === 'file' ?
                el?.valueRepositoryCode ?
                  {fieldHeader: el?.value, repositoryFieldCode: el?.valueRepositoryCode} :
                  '' :
                el?.value || '',
            field: {
              ...el,
              repositoryName: el.repository,
              dataType: el?.dataType ? el?.dataType : 'Text',
              fieldName: el.field,
              fieldType: el?.dataType || 'Text',
              globalField: el?.dbColumnName || '',
            },
            type: typeOptions.filter((item) => item.value === el.type)?.[0] || typeOptions[0],
            condition: getOptions(el?.dataType?.toLowerCase())?.filter(
              (e) => e.value === el.filterCondition,
            )[0],
            sqlValue: el.sqlExpression,
          };
        });
      newRules &&
        setInitialValues((prevState) => ({
          ...prevState,
          ...newInitialValues,
          sqlRules: newRules,
        }));
    }
  }, [selectedProcessorFields, filterCriteriaData]);
  useEffect(() => {
    if (filterCriteriaSuccessMsg || filterCriteriaErrorMsg) {
      setTimeout(() => {
        if (addFilterCriteriaStatus === 200 && filterCriteriaSuccessMsg && !saveRef.current) {
          handleNext && handleNext();
        }
        if (dataManagerRecordId && !isDataManager) {
          dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId));
          dispatch(fetchFilterCriteriaData(dataManagerRecordId, filterCriteriaType));
        }
        dispatch(resetFilterCriteriaData());
      }, 1500);
    }
  }, [filterCriteriaErrorMsg, filterCriteriaSuccessMsg]);

  const onSubmit = (data) => {
    const code = recordCode;
    if (code) {
      dispatch(submissionStart());
      const conditions =
        data?.sqlRules?.length > 0 ?
          data.sqlRules?.map((item, i) => {
            const {field, condition, ruleCode, sqlValue, value1, value, filterRuleId, type} =
                item;
            return {
              code: code,
              field: field.fieldName,
              filterCondition: condition.value,
              filterRuleId: filterRuleId ? filterRuleId : 0,
              repository: field.repository || field.repositoryName,
              ruleCode: ruleCode,
              sqlExpression: sqlValue,
              value: type.value === 'file' ? value?.fieldHeader : value ? value : '',
              value1: ['BETWEEN', 'NOT BETWEEN']?.includes(condition.value) ? value1 : '',
              type: ['isBlank', 'isNotBlank']?.includes(condition.value) ?
                '' :
                type?.value || 'value',
              dataType: field?.dataType || field.fieldType || 'Text',
              valueRepositoryCode: value?.repositoryFieldCode || '',
              dbColumnName: field.globalField ? field.globalField : '',
            };
          }) :
          [];
      const payload = {
        code: code,
        dmFilterSqlRuleRequests: conditions,
        deleteIds: deletedRules?.length > 0 ? deletedRules : [],
        resultExpression: data?.sqlExpression ? data?.sqlExpression : '',
        defaultOperator: data.resultExpCondition,
        tabType: filterCriteriaType,
        fileType: type,
        isDraft: 'N',
        lastStep: isDataManager ? 3 : !isDataManager && saveRef.current ? 3 : 4,
        dataManagerId: isDataManager ? dataManagerId : 0,
        dataManagerRecordId:isDataManager ? 0 : dataManagerRecordId
      };
      dispatch(postFilterCriteriaData(payload));
    }
  };

  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: {values, setFieldValue},
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];
    const copyDeleteArr = [...deletedRules];

    if (values.sqlRules[i]?.filterRuleId) {
      copyDeleteArr.push(values.sqlRules[i]?.filterRuleId);
    }
    copyArr.splice(i, 1);
    setDeletedRules(copyDeleteArr);
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values) => onSubmit(values)}
      >
        {(props) => {
          const {values, setFieldValue, errors, handleChange, dirty} = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <div>
                <BreadCrums
                  name={exportManagerRecord ? 'Export Manager Code' : 'Import Template Record Name'}
                  code={infoData?.recordCode || ''}
                  description={
                    exportManagerRecord ?
                      'Export Manager Description' :
                      'Import Template Record  Description'
                  }
                  descriptionValue={infoData?.recordDescription || ''}
                  returnType={'Type'}
                  returnTypeValue={infoData?.recordType || ''}
                />
              </div>
              <Form noValidate>
                <FieldArray
                  name="sqlRules"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        <div className="table-header new-standard-textfields">
                          <Typography variant="h4"></Typography>

                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              setOpen(true);
                            }}
                          >
                            <AddIcon />
                            Add Duplicate Criteria
                          </Button>
                        </div>
                        {values.sqlRules.map((rule, index) => (
                          <>
                            <Field
                              key={index}
                              name={`sqlRules[${index}]`}
                              component={FilterCriteriaBuilder}
                              index={index}
                              isReports={true}
                              mappedFieldsData={
                                Array.isArray(recordFormatFieldsData) ? recordFormatFieldsData : []
                              }
                              handleDelete={() => {
                                setIsDelete(true);
                                currentDeleteIndex.current = index;
                                arrayHelperRef.current = arrayHelpers;
                                handleDirty(true);
                              }}
                              editExisting={editExisting}
                              dmTempRecordAccess={dmTempRecordAccess}
                            />
                          </>
                        ))}
                        <RadioGroup
                          aria-label="resultExpCondition"
                          name="resultExpCondition"
                          value={values.resultExpCondition}
                          onChange={(e) => {
                            handleChange(e);
                            const result = values.sqlRules.map((el, i) => el.ruleCode);
                            resultRef.current = false;
                            setFieldValue('sqlExpression', result.join(` ${e.target.value} `));
                          }}
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            flexDirection: 'row',
                          }}
                        >
                          <FormControlLabel
                            value="AND"
                            control={
                              <Radio color="primary" disabled={values.resultExpCondition == ''} />
                            }
                            label="AND"
                          />
                          <FormControlLabel
                            value="OR"
                            control={<Radio color="primary" />}
                            label="OR"
                            disabled={values.resultExpCondition == ''}
                          />
                        </RadioGroup>
                      </>
                    );
                  }}
                />

                <div className="d-flex justify-content-space-between align-items-center mt-1 global-field-textfields mt-3 new-standard-textfields">
                  <div className="col-11 pl-0 form-group">
                    <TextField
                      className={` ${classes.labelName} `}
                      placeholder="Result Expression"
                      margin="dense"
                      name="sqlExpression"
                      variant="outlined"
                      label="Result Expression"
                      value={values.sqlExpression}
                      required
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setFieldValue('resultExpCondition', '');
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      error={Boolean(errors.sqlExpression)}
                    />
                    <FormHelperText variant="outlined">
                      {errors.sqlExpression ? errors.sqlExpression : ''}
                    </FormHelperText>
                  </div>
                  {/* <Button
                    variant="outlined"
                    className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                    onClick={() => {
                      setOpenTestForm(true);
                    }}
                  >
                    Test
                  </Button> */}
                </div>
                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="button"
                    onClick={() => {
                      // reset(initialValues);
                      // if (!Object.keys(filterRuleGroupData)?.length) {
                      //   setFormDataFormula([]);
                      //   setFormData([]);
                      // } else {
                      //   setReset(!tableDataReset);
                      // }
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {isDraftRecord === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  {values.sqlRules.length > 0 ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                      onClick={() => {
                        saveRef.current = false;
                        handleDirty(false, 'fixed');
                      }}
                    >
                      {isDataManager ? 'Finish' : 'Save & Next'}
                    </Button>
                  ) : (
                    <Tooltip title="Please add atleast one rule to continue">
                      <span>
                        <Button
                          type="submit"
                          variant="outlined"
                          className={`mx-1 search-btn ${classes.buttonRoot}`}
                          disabled
                        >
                          {isDataManager ? 'Finish' : 'Save & Next'}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </div>

                <DeleteTableRecordPopup
                  open={isDelete}
                  dialogClose={handleDeleteClose}
                  title="Delete Filter Criteria"
                  value={`Are you sure you want to delete the ${
                    values?.sqlRules[currentDeleteIndex.current]?.ruleCode
                  }  Filter Criteria?`}
                  handleSubmit={handleDeleteRule}
                />
              </Form>
              <DialogBox
                open={open}
                dialogClose={handleClose}
                //  title="Search Fields"
                title={
                  <div className="dialog-breadcrum">
                    <p className="dialoge-title-breadcrum">
                      <b>Search Fields</b>
                    </p>
                    <BreadCrums
                      name={'Import Template Record Name'}
                      code={infoData?.recordCode}
                      description={'Import Template Record Description'}
                      descriptionValue={infoData?.recordDescription}
                    />
                  </div>
                }
                maxWidth="xl"
              >
                <SearchFields
                  isReportsFilter={true}
                  isReports={true}
                  resultExpCondition={values.resultExpCondition}
                  setRules={(value) => {
                    setFieldValue('sqlRules', value);
                  }}
                  rules={values.sqlRules}
                  resultRef={resultRef}
                  tempSelectedRows={tempSelectedRows}
                  handleClose={handleClose}
                  mapFields={true}
                  setTempSelectedRows={setTempSelectedRows}
                  setInitialValues={setInitialValues}
                  setFieldValue={setFieldValue}
                  filterValues={values}
                  filterMethodRef={filterMethodRef}
                  isDMFilter={true}
                />
              </DialogBox>
            </>
          );
        }}
      </Formik>
      {(isFilterCriteriaLoading || isBasicInfoLoading || loading || printUsageIsLoading) && (
        <PageLoader />
      )}
      {(filterCriteriaErrorMsg || basicInfoErrorMsg || errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar
          errorMsg={filterCriteriaErrorMsg || basicInfoErrorMsg || errorMsg || printUsageErrorMsg}
        />
      )}
      {(filterCriteriaSuccessMsg || basicInfoSuccessMsg || successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            filterCriteriaSuccessMsg || basicInfoSuccessMsg || successMsg || printUsageSuccessMsg
          }
        />
      )}
    </>
  );
};
export default FilterCriteria;
